import React, {Component} from 'react';
import './trace.less';
import NavBar from "./elements/NavBar";
import {BrowserRouter, Route, Link} from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import ScrollToTop from "./elements/ScrollToTop";

class App extends Component {
  render() {

    return <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ScrollToTop>
          <div>
            <Route exact path="/" component={Home}/>
            <Route path="/about" component={About}/>
          </div>
        </ScrollToTop>
      </BrowserRouter>
    </div>;
  }
}

export default App;
